import { reactPlugin } from '@/config/telemetry';

export type SiteComplianceTelemetryProperties = Record<
  string,
  boolean | number | string | null | undefined
>;

export const trackSiteComplianceEvent = (
  name: string,
  properties: SiteComplianceTelemetryProperties = {},
) => {
  const sanitizedProperties = Object.entries(properties).reduce<
    Record<string, boolean | number | string | null>
  >((acc, [key, value]) => {
    if (value !== undefined) {
      acc[key] = value;
    }

    return acc;
  }, {});

  try {
    reactPlugin.trackEvent({ name }, sanitizedProperties);
  } catch {
    // Telemetry must never block an admin mutation or route render.
  }
};
